/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { Campaign } from "@mui/icons-material";
// import { logout } from "../../src/store/userSilce";

function SoundDir({ dir, onFinish, time }) {
  const [dirUrl, setDirUrl] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  // const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const token = user.token;
  useEffect(() => {
    const axiosConfig = {
      baseURL: process.env.REACT_APP_API_URL,
      headers: { authtoken: "bearer " + token },
    };
    const axiosInstance = axios.create(axiosConfig);
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          `/getfilesound/DIR_END/${dir}`
        );
        const url = response.data;
        setTimeout(() => {
          //setNumUrl(urlNum);
          setDirUrl(url);
        }, time);
      } catch (error) {
        console.error("Error fetching audio: ", error);
      }
    };
    fetchData();
  }, []);
  return (
    <div>
      {dirUrl ? (
        <>
          <audio
            src={"data:audio/mp3;base64," + dirUrl}
            autoPlay
            controls={!isPlaying}
            type="audio/mpeg"
            onEnded={() => {
              onFinish(); // Call onFinish function
              setIsPlaying(false); // Set isPlaying to false
            }}
            onPlay={() => setIsPlaying(true)}
          />
          {isPlaying && <Campaign fontSize="large" />}
        </>
      ) : (
        <>
         <p>Loading audio...  <br />  <p style={{color:'red'}}>กรุณารอ 5 วินาที (ห้ามกดปุ่ม Play หรือ Refresh Browser)</p></p>
        </>
      )}
    </div>
  );
}

export default SoundDir;
